import React, { Component } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var hover = {
  backgroundColor: '#f1f1f1',
  cursor: 'pointer'
};
var active = {
  backgroundColor: 'dodgerblue',
  color: '#ffffff'
};
var style = {
  padding: '7px',
  fontSize: '16px',
  fontWeight: 100,
  hover: hover,
  active: active
};

var LiCons = function LiCons(props) {
  var _style = _extends(_extends({}, style), props.style);

  return /*#__PURE__*/React.createElement("li", {
    style: props.actived ? _extends(_extends(_extends({}, _style), style.active), _style.active) : props.hovered ? _extends(_extends(_extends({}, _style), style.hover), _style._hover) : _style,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onMouseDown: props.onClick
  }, props.children);
};

var Suggestion = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Suggestion, _Component);

  function Suggestion(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleOnMouseEnter = function (e) {
      _this.setState({
        hovered: true
      });
    };

    _this.handleOnMouseLeave = function (e) {
      _this.setState({
        hovered: false
      });
    };

    _this.state = {
      hovered: false,
      actived: false
    };
    return _this;
  }

  var _proto = Suggestion.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        actived = _this$props.actived,
        children = _this$props.children,
        onClick = _this$props.onClick,
        style = _this$props.style;
    var hovered = this.state.hovered;
    return /*#__PURE__*/React.createElement(LiCons, {
      style: style,
      hovered: !!hovered,
      actived: !!actived,
      onMouseEnter: this.handleOnMouseEnter,
      onMouseLeave: this.handleOnMouseLeave,
      onClick: onClick
    }, children);
  };

  return Suggestion;
}(Component);

Suggestion.propTypes = {};

var style$1 = {
  position: 'absolute',
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  border: '1px solid #f1f1f1',
  borderTop: 0,
  borderRadius: '3px',
  borderTopRightRadius: 0,
  borderTopLeftRadius: 0,
  maxHeight: 'calc(~"100vh - 100px")',
  maxWidth: '300px',
  overflowY: 'auto',
  backgroundColor: 'rgba(255,255,255,1)',
  textAlign: 'left',
  marginLeft: 'auto',
  marginRight: 'auto',
  left: 0,
  right: 0
};

var UlCons = function UlCons(props) {
  return /*#__PURE__*/React.createElement("ul", {
    style: _extends(_extends({}, style$1), props.style)
  }, props.children);
};

var Suggestions = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Suggestions, _Component);

  function Suggestions() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Suggestions.prototype;

  _proto.castToSuggestionItems = function castToSuggestionItems(items, activedIdx, _onClick) {
    return items.map(function (item, idx) {
      return /*#__PURE__*/React.createElement(Suggestion, {
        key: idx,
        actived: activedIdx === idx,
        onClick: function onClick() {
          return _onClick(idx);
        }
      }, item.getSuggestion());
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        onClick = _this$props.onClick,
        activedIndex = _this$props.activedIndex,
        style = _this$props.style;
    return /*#__PURE__*/React.createElement(UlCons, {
      style: style
    }, this.castToSuggestionItems(children, activedIndex, onClick));
  };

  return Suggestions;
}(Component);

var InputCons = function InputCons(props) {
  return /*#__PURE__*/React.createElement("input", _extends({}, props, {
    ref: function ref(input) {
      return props.inputRef(input);
    },
    type: "text",
    autoComplete: "off"
  }));
};

var InputAutoSuggest = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InputAutoSuggest, _Component);

  function InputAutoSuggest(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelect = function (idx) {
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      var e = {
        target: {
          name: name,
          value: _this.state.filteredData[idx].originalData
        }
      };

      _this.setState({
        filteredData: []
      });

      onChange(e);
    };

    _this.handleOnKeyDown = function (e) {
      var _this$state = _this.state,
          activedIndex = _this$state.activedIndex,
          filteredData = _this$state.filteredData;

      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          if (activedIndex > 0) _this.setState({
            activedIndex: activedIndex - 1
          });
          break;

        case 'ArrowDown':
          if (activedIndex < filteredData.length - 1) _this.setState({
            activedIndex: activedIndex + 1
          });
          break;

        case 'Enter':
          if (activedIndex !== -1) _this.handleSelect(activedIndex);
          break;

        case 'Escape':
          _this.setState({
            filteredData: []
          });

          break;

        default:
          if (activedIndex !== -1) _this.setState({
            activedIndex: -1
          });
      }
    };

    _this.handleInputOnChange = function (e) {
      var search = e.target.value;
      var _this$props2 = _this.props,
          filter = _this$props2.filter,
          onChange = _this$props2.onChange;
      var filteredData = [];

      if (search) {
        filteredData = _this.state.data.where(function (item) {
          return filter ? filter(item) : item.toLowerCase().indexOf(search.toLowerCase()) >= 0;
        });
      }

      _this.setState({
        filteredData: filteredData
      });

      onChange(e);
    };

    _this.handleOnBlur = function () {
      _this.setState({
        filteredData: []
      });

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.state = {
      activedIndex: -1,
      filteredData: [],
      data: _this.getData(props.data)
    };

    String.prototype.bold = function (bold) {
      var indexOfSearch = this.toLowerCase().indexOf(bold.toLowerCase());

      if (indexOfSearch >= 0) {
        return /*#__PURE__*/React.createElement("div", null, this.substr(0, indexOfSearch), /*#__PURE__*/React.createElement("b", null, this.substr(indexOfSearch, bold.length)), this.substr(indexOfSearch + bold.length));
      } else {
        return this;
      }
    };

    Array.prototype.where = function (condition) {
      var ret = [];

      for (var i = 0; i < this.length; i++) {
        if (condition(this[i].originalData)) {
          ret.push(this[i]);
        }
      }

      return ret;
    };

    return _this;
  }

  var _proto = InputAutoSuggest.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      var data = this.getData(nextProps.data);

      if (nextProps.data !== data) {
        this.setState({
          data: data
        });
      }
    }
  };

  _proto.getData = function getData(propData) {
    var _this2 = this;

    return propData.map(function (item) {
      return {
        getSuggestion: function getSuggestion() {
          return _this2.display(item, _this2.props.value);
        },
        originalData: item
      };
    });
  };

  _proto.display = function display(item, search) {
    var hasAnySearch = search;
    var hasSpecialDisplayTreatment = this.props.display;

    if (hasSpecialDisplayTreatment) {
      var displayItem = this.props.display(item);
      var isStringType = typeof displayItem === 'string';

      if (hasAnySearch && isStringType) {
        return displayItem.bold(search);
      } else {
        return displayItem;
      }
    } else {
      if (hasAnySearch) {
        return item.bold(search);
      } else {
        return item;
      }
    }
  };

  _proto.focus = function focus() {
    this.inputRef.focus();
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state2 = this.state,
        activedIndex = _this$state2.activedIndex,
        filteredData = _this$state2.filteredData;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputCons, _extends({}, this.props, {
      inputRef: function inputRef(_inputRef) {
        return _this3.inputRef = _inputRef;
      },
      onChange: this.handleInputOnChange,
      onKeyDown: this.handleOnKeyDown,
      onBlur: this.handleOnBlur
    })), /*#__PURE__*/React.createElement(Suggestions, {
      style: this.props.style,
      onClick: this.handleSelect,
      activedIndex: activedIndex
    }, filteredData));
  };

  return InputAutoSuggest;
}(Component);

export default InputAutoSuggest;
export { Suggestion, Suggestions };
//# sourceMappingURL=index.modern.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-autosuggest/dist/index.modern.js
// module id = 106
// module chunks = 1